import { ASPIRASI } from "views/app-views/aspirasi";

const URLS = Object.freeze({
  LOGIN: `/api/v1/auth/login`,
  REGISTER: `/auth/register`,
  STORE_GOOGLE_ACCOUNT: `/user/auth-google`,
  ACTIVATION: `/send-activation`,
  RESET_PASSWORD: `/auth/reset-password`,
  FORGOT_PASSWORD: `/auth/forgot-password`,
  RESEND_ACTIVATION: `user/resend-activation`,
  PROFILE: `/users`,
  USER: "/users",
  CONTENT: "/content",
  DEWAN: "/dewan",
  EMPLOYEE: "/employee",
  MEETING: "/meeting",
  PROGRAM: "/program",
  ACTIVITY: "/activity",
  RESES: "/reses",
  ASPIRASI: "/aspiration",
  KEGIATAN: "/kegiatan",
  NOTIFIKASI: "/notifikasi",
  PESAN: "/pesan",
  FRAKSI: "/fraksi",
  DAPIL: "/electoralDistrict",
  DOCUMENT: "/document",
  KOMISI: "/komisi",
  PNS: "/pns",
  CATEGORY: "/category",
  VIDEO: "/video",
  IMAGE: "/image",
  GALLERY: "/gallery",
  MESSAGE: "/messages",
  DASHBOARD: "/dashboard/summary",
  CATEGORIZATION: "/categorization",
  TAG: "/tag",
  SUBCATEGORY: "/sub_categories",
  STATIC: "/static",
});

export default URLS;
